
import { Skeleton } from '@/components/ui/skeleton';

const HeroLoadingSkeleton = () => {
    return (
        <section className="relative overflow-hidden min-h-screen flex items-center pt-20 bg-background">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 sm:py-24 w-full">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-12 lg:gap-16 items-center">
                    <div>
                        <Skeleton className="h-8 w-48 mb-6 rounded-full" />
                        <Skeleton className="h-16 w-full mb-4" />
                        <Skeleton className="h-16 w-3/4 mb-6" />
                        <Skeleton className="h-8 w-full mb-2" />
                        <Skeleton className="h-8 w-5/6 mb-8" />
                        <div className="flex gap-4">
                            <Skeleton className="h-12 w-48 rounded-full" />
                            <Skeleton className="h-12 w-48 rounded-full" />
                        </div>
                    </div>
                    <div>
                        <Skeleton className="h-[450px] w-full max-w-sm mx-auto rounded-3xl" />
                    </div>
                </div>
            </div>
        </section>
    );
}

export default HeroLoadingSkeleton;
